import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CarrierConfigurationService {
    constructor(
        private _httpClient: HttpClient,
    ) { }
    getCarrierConfiguration(): Observable<any> {
        return this._httpClient.get(environment.apiBaseUrl + '/carrier-configuration/');
    }
    addCarrierConfiguration(data: any): Observable<any> {
        return this._httpClient.post(environment.apiBaseUrl + '/carrier-configuration/', data);
    }
    addCarrierCofiguration(data: any): Observable<any> {
        return this.addCarrierConfiguration(data);
    }
    updateCarrierConfigurationById(id: string, data): Observable<any> {
        return this._httpClient.put(environment.apiBaseUrl + '/carrier-configuration/' + id, data);
    }
    getCarrierConfigurationById(id: string): Observable<any> {
        return this._httpClient.get(environment.apiBaseUrl + '/carrier-configuration/' + id);
    }
    getCourierCompanies(): Observable<any> {
        return this._httpClient.get(environment.apiBaseUrl + '/carrier-configuration/courier-companies/get-all');
    }
}
